import "./insertAmlak.css";
import {Button, Form, Input, notification, Row} from "antd";
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";
import {useNavigate} from "react-router-dom";

const InsertAmlak = ({setStep}) => {

    const navigate = useNavigate();

    const handleSubmit = (values) => {
        console.log(values)

        Axios.post('', `${Api}add-amlak-panel`, values).then(async (data) => {
            if(data.statusCode === 200 || data.statusCode === 201){
                await notification.open({
                    message: "موفقیت",
                    description: "درخواست با موفقیت انجام شد!",
                    style: {
                        background: "#43a047",
                        color: "white",
                        fontFamily: "IRANSansMobileFaNum",
                        borderRadius: "5px",
                    }
                })

                await setStep(1);

                // await console.log("alslslsls")
            }
        })
    }


    return(<div className={"body"}>
        <Row justify={"center"}>
            <Form className={"container"} onFinish={handleSubmit}
                  initialValues={{
                      ["diskUsage"]: 0,
                      ["disk"]: 0,
                      modifier: 'public',
                  }}
            >

                <label className={"label"}>کد املاک</label>
                <Form.Item name={"codeAmlak"}
                    rules={[{ required: true,
                        message: "کد املاک الزامی است!"
                    }]}
                >
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"}>استان</label>
                <Form.Item name={"ostan"}
                           rules={[{ required: true,
                               message: "استان الزامی است!"
                           }]}
                >
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"} >شناسه ثبت</label>
                <Form.Item name={"id_sabt"}>
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"} >نام شرکت</label>
                <Form.Item name={"name_sherkat"}>
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"} >فضای اختصاص داده شده (به گیگ)</label>
                <Form.Item name={"disk"}>
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"} >فضای استفاده شده(به گیگ)</label>
                <Form.Item name={"diskUsage"}>
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"} >تلفن 1</label>
                <Form.Item name={"tel_1"}>
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"} >تلفن 2</label>
                <Form.Item name={"tel_2"}>
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"}>تلفن 3</label>
                <Form.Item name={"tel_3"}>
                    <Input className={"input"} />
                </Form.Item>

                <label className={"label"}>desc_tel</label>
                <Form.Item name={"desc_tel"}>
                    <Input className={"input"} style={{
                        fontSize: "15px"
                    }}/>
                </Form.Item>

                <label className={"label"}>آدرس شرکت</label>
                <Form.Item name={'address_sherkat'}>
                    <Input.TextArea className={"input"} style={{
                        fontSize: "15px"
                    }} />
                </Form.Item>

                <label className={"label"}>desc_address</label>
                <Form.Item name={"desc_address"}>
                    <Input.TextArea className={"input"} style={{
                        fontSize: "15px"
                    }} />
                </Form.Item>

                <Button type={"primary"} style={{minWidth: "60px", maxWidth:"100px", borderRadius: "20px"}} htmlType={"submit"}>ثبت</Button>
            </Form>
        </Row>
        </div>)
}

export default InsertAmlak;